export const Arrow_icon_around_right = require('../Assets/Icons/Arrow_Small_Right.svg')